import { clsx } from "clsx";
import { forwardRef, type InputHTMLAttributes, useId } from "react";

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  function Checkbox({ label, className, id: externalId, ...props }, ref) {
    const generatedId = useId();
    const id = externalId ?? generatedId;

    return (
      <div className={clsx("flex items-center gap-2", className)}>
        <input
          ref={ref}
          id={id}
          type="checkbox"
          className="h-4 w-4 cursor-pointer rounded border-edge-hard text-adara-700 accent-adara-700 focus:ring-2 focus:ring-adara-500 focus:ring-offset-1"
          {...props}
        />
        {label && (
          <label
            htmlFor={id}
            className="cursor-pointer text-sm text-sub select-none"
          >
            {label}
          </label>
        )}
      </div>
    );
  },
);
